export default __webpack_public_path__ + "static/media/06.d18a17c2.jpg";